import { render, staticRenderFns } from "./MediaMatrixLayoutSetup.vue?vue&type=template&id=c612e498&scoped=true"
import script from "./MediaMatrixLayoutSetup.vue?vue&type=script&lang=ts"
export * from "./MediaMatrixLayoutSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c612e498",
  null
  
)

export default component.exports